<template>
  <div
    class="row-early-price"
    v-if="data.earlyPrice"
  >
    <div class="row-early-amount">{{ data.earlyPrice | currencyFormat }}</div>
    <div class="row-early-date">{{ data.earlyDate }}</div>
  </div>
  <div v-else>
    N/A
  </div>
</template>
  
  <script>
export default {
  name: "row-early-price",
  props: {
    data: {
      type: Object,
    },
  },
};
</script>
  
  <style lang="scss">
.row-early-price {
  .row-early-date {
    font-size: 12px;
    color: #4d4d4d;
    opacity: 0.5;
  }
}
</style>